import { render, staticRenderFns } from "./TaskTimeline.vue?vue&type=template&id=56bacb1a&scoped=true&"
import script from "./TaskTimeline.vue?vue&type=script&lang=js&"
export * from "./TaskTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bacb1a",
  null
  
)

export default component.exports